import {BaseConverter} from '../../base/converters/base-converter.converter';
import {IdCard} from '../../shared/DTO/idCard';
import {IdCardModel} from '../models/idcard.model';
import * as moment from 'moment';

export class IdCardConverter extends BaseConverter<IdCardModel, IdCard> {
  constructor() {
    super();
  }

  convertToDto(model: IdCardModel): IdCard {
    if (!model) {
      return;
    }
    return {
      type: model.type,
      state: model.state,
      releaseDate: model.releaseDate.valueOf(),
      releaseBy: model.releaseBy,
      id: model.id,
      files: model.files,
      expirationDate: model.expirationDate.valueOf(),
      country: model.country,
      city: model.city
    };
  }

  convertToModel(dto: IdCard): IdCardModel {
    if (!dto) {
      return;
    }
    let model: IdCardModel = new IdCardModel();
    model.city = dto.city;
    model.country = dto.country;
    model.expirationDate = moment(dto.expirationDate).format('DD/MM/AAAA');
    model.files = dto.files;
    model.id = dto.id;
    model.releaseBy = dto.releaseBy;
    model.releaseDate = moment(dto.releaseDate).format('DD/MM/AAAA');
    model.state = dto.state;
    model.type = dto.type;
    return model;
  }

}
